import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { ProductionOrderRequest } from './common/productionOrderRequest';
import type { ProductionOrder } from 'shared/productionOrders/domain/productionOrder';

export interface CreateProductionOrderResponse {
  ok: true;
  productionOrder: ProductionOrder;
}

export function useCreateProductionOrderApi() {
  return useCreateEntityApi<ProductionOrderRequest, CreateProductionOrderResponse>({
    url: 'productionorder',
    translate: (t) => t.productionOrders.actions.create,
    async processOk(response) {
      const json = (await response.json()) as ProductionOrder;
      return {
        ok: true,
        productionOrder: json,
      };
    },
  });
}
